<template>
  <div>
    <masthead background-image="home-masthead.jpg"
              text="Premium wines, beers and spirits for leading independents across the UK" v-bind:show-logo="false"/>
    <home-product-slider/>
    <order-steps/>
    <content-blocks ref="contentBlocks"/>
    <product-slider-block/>
    <site-footer/>
  </div>
</template>

<script>
  import Masthead from '@/components/Masthead.vue'
  import SiteFooter from '@/components/SiteFooter.vue'
  import OrderSteps from '@/components/OrderSteps'
  import ContentBlocks from '@/components/ContentBlocks'
  import HomeProductSlider from '@/components/HomeProductSlider'
  import ProductSliderBlock from "../components/ProductSliderBlock";

  export default {
    name: 'HomePage',
    components: {
      ProductSliderBlock,
      HomeProductSlider,
      ContentBlocks,
      OrderSteps,
      Masthead,
      SiteFooter
    },
    data() {
      return {
        globalContent: null,
        pageContent: null
      };
    },
    methods: {
      loadPageContent: function () {
        this.$root.$api.getPageBySlug('global-content')
          .then(response => {
            if (response.data != null) {
              this.globalContent = response.data.pages[0];
              this.$refs.contentBlocks.loadContent(this.globalContent.content);
            }
          }).catch(error => {
          console.log(error);
        })
      },
    },
    created: function () {
      this.loadPageContent();
    }
  };
</script>
